import { Box, Grid, Theme, Typography } from "@mui/material";
import { ViewProfileProps } from "../types";
import { KeyValue } from "../../ApplicationDetails/personalDetails";
import React from "react";
import { SubHeading } from "../../investors/components";
import { checkAddressField } from '../../../utils/utilityFunctions';
import { ContactRelations } from '../../../utils/constant';

export default function ContactDetails({ overviewData }: { overviewData: Partial<ViewProfileProps> }): JSX.Element {
    const { applicants } = overviewData;
    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'

                })}
            >
                <Box>
                    <Grid container>
                        <Typography variant='body_600' sx={(theme: Theme) => ({ fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
                            Contact Details
                        </Typography>
                        {applicants?.map((applicant, index: number) => {
                            const title = [
                                'First Applicant Details',
                                'Second Applicant Details',
                                'Third Applicant Details',
                            ][index];
                            const isIndividual = `${applicant?.onboardingSubType ?? ''}`.toLowerCase() === 'individual';
                            return (
                                <React.Fragment key={applicant.id}>
                                    <SubHeading sx={{ letterSpacing: "0.02px" }}>
                                        {title}
                                    </SubHeading>

                                    <Grid
                                        item
                                        container
                                        // pt={2}
                                        // pb={5}
                                        rowSpacing={3}
                                        columnSpacing={5.5}
                                        direction="row"
                                    // justifyContent="space-between"
                                    // alignItems="flex-start"
                                    >

                                        <KeyValue title={'E-Mail ID'} description={applicant.email} />
                                        <KeyValue
                                            title={'This email id belongs to'}
                                            description={
                                                ContactRelations[applicant.emailPersonRelation || ''] ||
                                                applicant.emailPersonRelation
                                            }
                                        />
                                        <KeyValue
                                            title={'Mobile Number'}
                                            description={applicant.mobile ?
                                                (applicant.countryCode
                                                    ? applicant.countryCode + '-' + applicant.mobile
                                                    : applicant.mobile) : '-'
                                            }
                                        />
                                        <KeyValue
                                            title={'This mobile number belongs to'}
                                            description={
                                                ContactRelations[applicant.phonePersonRelation || ''] ||
                                                applicant.phonePersonRelation
                                            }
                                        />
                                        {/* {applicant.kraMobileNumber && (
                                            <KeyValue
                                                title={'KRA Mobile Number'}
                                                description={applicant.kraMobileNumber}
                                            />
                                        )} */}
                                        {/* <KeyValue
                                            title={'Phone Number (Office)'}
                                            description={applicant.phoneNumberoffice}
                                        />
                                        <KeyValue
                                            title={'Phone Number (Residential)'}
                                            description={applicant.phoneNumberResidence}
                                        /> */}
                                        <KeyValue
                                            title={'Alternate Number'}
                                            description={applicant.alternateNumber ?
                                                (applicant.alternateNumberCountryCode
                                                    ? applicant.alternateNumberCountryCode + '-' + applicant.alternateNumber || '-'
                                                    : applicant.alternateNumber) : '-'
                                            }
                                        />
                                        <KeyValue
                                            title={'Whatsapp Number'}
                                            description={applicant.whatsappNumber ?
                                                (applicant.whatsappNumberCountryCode
                                                    ? applicant.whatsappNumberCountryCode + '-' + applicant.whatsappNumber || '-'
                                                    : applicant.whatsappNumber) : '-'
                                            }
                                        />
                                        {!!applicant?.addresses?.length &&
                                            applicant?.addresses.map((address) => (
                                                <React.Fragment key={address.id}>
                                                    <KeyValue
                                                        title={`${address.address_type} Address`}
                                                        description={`${checkAddressField(
                                                            address.address1
                                                        )}${checkAddressField(address.address2)}
                                                         ${checkAddressField(address.address3)}
                                                    ${`${address?.city ?? ''}`.toLowerCase() === 'others'
                                                            ? `${checkAddressField(address.otherCity)}`
                                                            : `${checkAddressField(address.city)}`}
                                                    ${`${address?.state ?? ''}`.toLowerCase() === 'others'
                                                            ? `${checkAddressField(address.otherState)}`
                                                            : `${checkAddressField(address.state)}`}
                                                         ${checkAddressField(address.country)}${address.pincode}`}
                                                        sx={{
                                                            textTransform: 'capitalize',
                                                        }}
                                                    />
                                                    {
                                                        `${address.address_type ?? ''}`.toLowerCase() === 'overseas' && (
                                                            <KeyValue
                                                                title={`${address.address_type
                                                                    ?.trim()
                                                                    .toLowerCase()
                                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                                                    } Mobile Number`}
                                                                description={address.countryNameAndCode
                                                                    ? address.countryNameAndCode + '-' + address.mobile
                                                                    : address.mobile}
                                                            />
                                                        )
                                                    }
                                                </React.Fragment>
                                            ))}
                                    </Grid>

                                </React.Fragment>
                            );
                        })}
                    </Grid>
                </Box>
            </Box >
        </>
    )
}